import { Badge } from '@ntconsult/aluma-react';
import type { TagOption } from '../types/Tag';

/**
 * A cor da tag é dado do Axiis (hex livre), não token: vai num ponto ao lado
 * do nome, como no `TagsCombobox`, e o badge fica neutro.
 */
export function TagBadge({ tag }: { tag: TagOption }) {
  return (
    <Badge
      variant="soft"
      tone="neutral"
      size="sm"
      icon={
        <span
          aria-hidden="true"
          className="inline-block h-2 w-2 shrink-0 rounded-full"
          style={{ backgroundColor: tag.color }}
        />
      }
    >
      {tag.name}
    </Badge>
  );
}
